require('./basicTable.style.scss');

class BasicTableController {
    constructor($element) {
        this._$element = $element;
        this.tableClass = this.tableClass || 'table-bordered';
        this.columnNames = this.columnNames || ['#', 'First Name', 'Last Name', 'Age', 'City', 'Country'];
        this.columnIds = this.columnIds || ['orderNum', 'firstName', 'lastName', 'age', 'city', 'country'];
        this.rowIdProperty = this.rowIdProperty || 'id';
        this.selectedItems = this.selectedItems || [];

        this.dataSet = this.dataSet || [
                {
                    id: '1',
                    orderNum: '1',
                    firstName: 'Anna',
                    lastName: 'Pitt',
                    age: 36,
                    city: 'New York',
                    country: 'USA'
                }
            ];
    }

    $onInit(){
        this.columnSortCriterias = this.setDefault(this.columnSortCriterias, this.columnIds.slice());
    }

    setDefault(object, value) {
        return (typeof object === 'undefined') ? value : object ;
    }

    setRowId(id) {
        if(!this.multiSelect) {
            this.selectedRowId = id;
        } else {
            this.selectedRowId = id;
            if(this.selectedItems.filter(i => i == id).length > 0) {
                let index = this.selectedItems.indexOf(id);
                this.selectedItems.splice(index, 1);
            } else {
                this.selectedItems.push(id);
            }
        }
    }

    setSortCriteria(name, event) {
        if(this.waitResponseFlag || !this.enableSorting) return;
        this._$element.find('th').removeClass('sort asc desc');
        if (this.sortCriteria === name) {
            this.sortCriteria = '-' + name;
            angular.element(event.target).removeClass('sort desc');
            angular.element(event.target).addClass('sort asc');
        } else {
            this.sortCriteria = name;
            angular.element(event.target).removeClass('sort asc');
            angular.element(event.target).addClass('sort desc');
        }

    }
}

BasicTableController.$inject = ['$element'];

const basicTableComponent = {
    controller: BasicTableController,
    controllerAs: 'basicTableCtrl',
    require: ['ngModel'],
    scope: {},
    template: require('./basicTable.template.html'),
    bindings: {
        responsive: '<?',
        tableClass: '@?',
        columnNames: '<?',
        columnIds: '<?',
        columnSortCriterias: '<?',
        dataSet: '=?ngModel',
        rowIdProperty: '@?',
        selectedRowId: '=?',
        enableSorting: '=?',
        sortCriteria: '=?',
        waitResponseFlag: '=?',
        clickable: '=?',
        multiSelect: '=?',
        selectedItems: '=?'
    }
};

module.exports = basicTableComponent;


// WEBPACK FOOTER //
// ./src/shared/basicTable/basicTable.component.js